export const staleTimes = {
  fifteenMinutes: 1000 * 60 * 15,
  fiveMinutes: 1000 * 60 * 5,
  none: 0,
  oneDay: 1000 * 60 * 60 * 24,
  oneMinute: 1000 * 60,
  twentySeconds: 1000 * 20,
};
